import { isProfileMan } from '.';
export function getWealthTitle(type) {
    return isProfileMan(type) ? 'Состояние' : 'Выручка';
}
